import React, { useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';
import { useExtraLiquidID } from '@pkg/hooks/liquid-id/useExtraLiquidID';

import { LiquidIdStyled, Wrapper } from './styles';

export const LiquidID = () => {
    const navigate = useNavigate();
    const primaryYat = useAppSelector((state) => state.user?.primaryYat);
    const currentUserId = useAppSelector((state) => state.user?.userAccount?.user.id);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const mouse = useRef({ x: 0, y: 0 });

    const onLiquidIDClick = () => {
        if (primaryYat) navigate(`/${primaryYat}?lid=1`, { state: { enableGoBack: true } });
    };

    const onLiquidIDMouseDown = (event: React.MouseEvent) => {
        mouse.current.x = event.clientX;
        mouse.current.y = event.clientY;
    };

    const onLiquidIDMouseUp = (event: React.MouseEvent) => {
        const x = event.clientX - mouse.current.x;
        const y = event.clientY - mouse.current.y;
        if (Math.sqrt(x * x + y * y) < 10) onLiquidIDClick();
    };

    useExtraLiquidID({
        ownerID: currentUserId,
        wrapperRef: wrapperRef,
        isScrollingElement: false,
        backgroundVisibility: false,
        delayRender: 1000,
    });

    return (
        <Wrapper onMouseDown={onLiquidIDMouseDown} onMouseUp={onLiquidIDMouseUp}>
            <LiquidIdStyled ref={wrapperRef} />
        </Wrapper>
    );
};
